import _extends from "@babel/runtime/helpers/esm/extends";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["onClose", "onSubmit", "validate", "linkReg", "linkFP", "headerTitle", "loginProps", "passwordProps"];
import React from 'react';
import { Field, Form } from 'react-final-form';
import classNames from 'classnames/bind';
import { defaultPropObject } from "../constants";
import getFieldIsInvalid from "../utils/getFieldIsInvalid";
import { isFunc } from "../utils/type";
import { Button } from '../Button';
import HeaderPopup from '../HeaderPopup';
import Textfield from '../Textfield';
import styles from './LoginForm.css';
var cx = classNames.bind(styles);

var LoginForm = function LoginForm(_ref) {
  var onClose = _ref.onClose,
      onSubmit = _ref.onSubmit,
      validate = _ref.validate,
      linkReg = _ref.linkReg,
      linkFP = _ref.linkFP,
      headerTitle = _ref.headerTitle,
      _ref$loginProps = _ref.loginProps,
      loginProps = _ref$loginProps === void 0 ? defaultPropObject : _ref$loginProps,
      _ref$passwordProps = _ref.passwordProps,
      passwordProps = _ref$passwordProps === void 0 ? defaultPropObject : _ref$passwordProps,
      rest = _objectWithoutProperties(_ref, _excluded);

  var handleFormSubmit = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(values, form) {
      var error;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return onSubmit(values, form);

            case 2:
              error = _context.sent;

              if (!error) {
                _context.next = 5;
                break;
              }

              return _context.abrupt("return", error);

            case 5:
              if (isFunc(onClose)) {
                onClose();
              }

              return _context.abrupt("return", null);

            case 7:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function handleFormSubmit(_x, _x2) {
      return _ref2.apply(this, arguments);
    };
  }();

  return /*#__PURE__*/React.createElement(HeaderPopup, {
    title: headerTitle,
    onClose: onClose
  }, /*#__PURE__*/React.createElement("div", _extends({
    className: cx('LoginForm')
  }, rest), /*#__PURE__*/React.createElement(Form, {
    onSubmit: handleFormSubmit,
    validate: validate,
    render: function render(_ref3) {
      var handleSubmit = _ref3.handleSubmit,
          submitting = _ref3.submitting,
          pristine = _ref3.pristine,
          hasSubmitErrors = _ref3.hasSubmitErrors,
          hasValidationErrors = _ref3.hasValidationErrors,
          dirtySinceLastSubmit = _ref3.dirtySinceLastSubmit;
      return /*#__PURE__*/React.createElement("form", {
        className: cx('Form'),
        onSubmit: handleSubmit
      }, /*#__PURE__*/React.createElement("div", {
        className: cx('Inputs')
      }, /*#__PURE__*/React.createElement("div", {
        className: cx('TextfieldWrapper')
      }, /*#__PURE__*/React.createElement(Field, {
        name: "login"
      }, function (_ref4) {
        var input = _ref4.input,
            meta = _ref4.meta;
        var fieldInvalid = getFieldIsInvalid(meta, dirtySinceLastSubmit);
        var error = fieldInvalid ? meta.error || meta.submitError : '';
        return /*#__PURE__*/React.createElement(Textfield, _extends({}, input, {
          type: "text",
          invalid: fieldInvalid,
          subText: error,
          label: "Email/\u0422\u0435\u043B\u0435\u0444\u043E\u043D/\u2116 \u043A\u0430\u0440\u0442\u044B"
        }, loginProps));
      })), /*#__PURE__*/React.createElement("div", {
        className: cx('TextfieldWrapper')
      }, /*#__PURE__*/React.createElement(Field, {
        name: "password"
      }, function (_ref5) {
        var input = _ref5.input,
            meta = _ref5.meta;
        var fieldInvalid = getFieldIsInvalid(meta, dirtySinceLastSubmit);
        var error = fieldInvalid ? meta.error || meta.submitError : '';
        return /*#__PURE__*/React.createElement(Textfield, _extends({}, input, {
          type: "password",
          invalid: fieldInvalid,
          subText: error,
          label: "\u041F\u0430\u0440\u043E\u043B\u044C"
        }, passwordProps));
      }))), /*#__PURE__*/React.createElement("div", {
        className: cx('Links-wrap')
      }, /*#__PURE__*/React.createElement("a", {
        href: linkReg,
        className: cx('SimpleLink')
      }, "\u0417\u0430\u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0438\u0440\u0443\u0439\u0442\u0435\u0441\u044C"), /*#__PURE__*/React.createElement("a", {
        href: linkFP,
        className: cx('SimpleLink')
      }, "\u0417\u0430\u0431\u044B\u043B\u0438 \u043F\u0430\u0440\u043E\u043B\u044C?")), /*#__PURE__*/React.createElement("div", {
        className: cx('Submit-wrapper')
      }, /*#__PURE__*/React.createElement(Button, {
        type: "submit",
        size: "small",
        disabled: pristine || hasValidationErrors || hasSubmitErrors && !dirtySinceLastSubmit || submitting
      }, "\u0412\u043E\u0439\u0442\u0438")));
    }
  })));
};

export default LoginForm;